/** Gift Certificate — document knowledge definition. Pure data. */
export default {
  id: 'gift-certificate',
  name: 'Gift Certificate',
  description: 'A redeemable voucher carrying a monetary or service value.',
  purpose: 'Gifting & Redemption',
  recommendedSizes: [{ name: 'Voucher', width: 1800, height: 900, unit: 'px' }],
  supportedOrientations: ['landscape'],
  supportsMultiplePages: false,
  supportsBleed: true,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: true,
  supportsTables: false,
  supportsPricing: true,
  supportsCTA: false,
  supportsOffers: true,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Title', 'Value', 'Recipient', 'Redemption Code', 'Terms', 'Expiry'],
};
